import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  
  private httpRequestsCount = 0;
  private cubeRequestsCount = 0;

  show() {
    this.loadingSubject.next(true);
  }

  hide() {
    this.loadingSubject.next(false);
  }

  showHttp() {
    this.httpRequestsCount++;
    if (this.httpRequestsCount === 1) {
      this.loadingSubject.next(true);
    }
  }

  hideHttp() {
    this.httpRequestsCount--;
    if (this.httpRequestsCount <= 0) {
      this.httpRequestsCount = 0;
      if (this.cubeRequestsCount === 0) {
        this.loadingSubject.next(false);
      }
    }
  }

  showCube() {
    this.cubeRequestsCount++;
    if (this.cubeRequestsCount === 1 && this.httpRequestsCount === 0) {
      this.loadingSubject.next(true);
    }
  }

  hideCube() {
    this.cubeRequestsCount--;
    if (this.cubeRequestsCount <= 0) {
      this.cubeRequestsCount = 0;
      if (this.httpRequestsCount === 0) {
        this.loadingSubject.next(false);
      }
    }
  }
}
